import React from "react";
import { Container } from "./styled";

export interface RadioButtonProps {
  name: string;
  value: string | boolean | number;
  label: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (() => void) | ((value: any) => void);
  color?: string;
}

export const RadioButton: React.FC<RadioButtonProps> = ({
  name,
  value,
  label,
  checked,
  disabled,
  onChange,
  color,
}: RadioButtonProps) => (
  <Container className="radio-button" color={color}>
    <label htmlFor={`${name}-${value}`}>
      <input
        id={`${name}-${value}`}
        data-testid={`${name}-${value}`}
        name={name}
        type="radio"
        value={label}
        onChange={() => onChange(value)}
        checked={checked}
        disabled={disabled}
      />
      <div className="check" />
      {label}
    </label>
  </Container>
);

export default RadioButton;
